module.exports = __webpack_public_path__ + "img/myphone_shop_banner_2.d7be9b92.jpeg";